var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A3EA5B",
    d: "M4.5-2a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A169F7",
    d: "M20-5C8.954-5 0 3.954 0 15s8.954 20 20 20 20-8.954 20-20S31.046-5 20-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6163",
    d: "M9.5 33a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AF",
    d: "M36 28c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.184 28-1.34-4.054H10.01L8.647 28H5.78l5.625-15.853h3.186L20.227 28h-3.043Zm-4.34-12.832-2.175 6.537h4.515l-2.153-6.537h-.187Zm14.975 2.725h-2.363v2.999H27.6c1.34 0 2.01-.505 2.01-1.516 0-.462-.15-.824-.45-1.088-.3-.264-.747-.395-1.34-.395Zm-.055 4.79h-2.308v3.405h2.55c.673 0 1.19-.146 1.548-.44.36-.292.539-.713.539-1.262 0-1.136-.777-1.703-2.33-1.703Zm-5 5.317V15.981h5.68c1.202 0 2.14.275 2.813.824.681.542 1.022 1.282 1.022 2.22 0 .614-.201 1.167-.604 1.658-.396.483-.89.776-1.483.879v.198c.783.08 1.417.38 1.9.9.484.513.725 1.136.725 1.868 0 1.055-.384 1.897-1.153 2.527-.77.63-1.817.945-3.142.945h-5.757Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 95.6,
    height: 99.6,
    x: -27.3,
    y: -27.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6114_77013",
    stdDeviation: 11.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvito);
export default __webpack_public_path__ + "static/media/avito.687569e25d541f1eb13d4b7010f5d02d.svg";
export { ForwardRef as ReactComponent };